import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';

const ProductEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ product: value }));
      if (validationErrors.product) {
        dispatch(clearValidationError('product'));
      }
    }
  };

  if (!contract) return null;

  return (
    <TextField
      label="Product *"
      value={contract.product}
      onChange={(e) => handleChange(e.target.value)}
      fullWidth
      variant="outlined"
      error={!!validationErrors.product}
      helperText={validationErrors.product}
      size="small"
    />
  );
};

export default ProductEditor;
